<ziro-collapsible-section-card
  [attr.data-automation]="'call-flow-destinations'"
  [isSwitchHidden]="true"
  [isCollapsible]="false"
  [title]="'tkey;admin.teams_voice_management.teams_auto_attendants.call_flow.destinations.header'"
  [subtext]="'tkey;admin.teams_voice_management.teams_auto_attendants.call_flow.destinations.helptext'"
>
  <div class="destinations__action-grid mb-4">
    <ziro-radio [fieldId]="'callRoutingOption'"></ziro-radio>
  </div>

  @if (formData.callRoutingOption === CallRoutingOption.PLAY_MENU_OPTIONS) {
    <ziro-call-flow-greetings
      [dataAutomation]="'call-flow-destination-greetings'"
      [tenantId]="tenantId()"
      [prompt]="callFlow().playMenuOptionSettings?.prompt"
      [pendingGreetingOption]="callFlow().selectedDestinationGreetingOption"
      [isDestinationsGreeting]="true"
      (greetingUpdate)="greetingUpdate.emit($event)"
    ></ziro-call-flow-greetings>

    <ziro-auto-attendants-menu-buttons
      [dialKeys]="callFlow().playMenuOptionSettings?.dialKeys"
      [tenantId]="tenantId()"
      [callFlow]="callFlow()"
    ></ziro-auto-attendants-menu-buttons>
  } @else if (formData.callRoutingOption === CallRoutingOption.DISCONNECT) {
    <div
      class="alert alert-warning d-flex align-items-center p-2 gap-2"
      role="alert"
      data-automation="disconnect-alert"
    >
      <i [class]="ziroIcons.CIRCLE_EXCLAMATION"></i>
      <div>
        {{ 'tkey;admin.teams_voice_management.teams_auto_attendant.call_flow.disconnect.alert' | translate }}
      </div>
    </div>
  }
  <div data-automation="redirect-call-card" [hidden]="formData.callRoutingOption !== CallRoutingOption.REDIRECT_CALL">
    <div>
      <ziro-select [fieldId]="'redirectType'" [inlineLabel]="false"></ziro-select>
      <ziro-select
        [fieldId]="'redirectDestination'"
        [inlineLabel]="false"
        [hidden]="!formData.redirectType"
      ></ziro-select>
      <ziro-text
        [fieldId]="'redirectDestinationNumber'"
        [inlineLabel]="false"
        data-automation="redirect-destination-number"
      ></ziro-text>
    </div>
  </div>

  <div class="destinations__directory-search p-2 mt-4" [attr.data-automation]="'directory-search'">
    <ziro-select [fieldId]="'directorySearchMethod'" [inlineLabel]="false"></ziro-select>
  </div>
</ziro-collapsible-section-card>
